import { CloudUpload, AlertTriangle, Loader2 } from 'lucide-react';
import { useOfflineSync } from '@/contexts/OfflineSyncContext';

/**
 * Top-right badge near the user/logout area that shows the count of
 * pending offline operations. Click to force-trigger sync.
 */
export const PendingBadge = () => {
  const { counts, isOnline, triggerSync } = useOfflineSync();
  if (!counts.total) return null;

  const hasFailed = counts.failed > 0;
  const hasSyncing = counts.syncing > 0;

  const color = hasFailed
    ? 'bg-red-100 text-red-700 hover:bg-red-200 border-red-300'
    : hasSyncing
      ? 'bg-blue-100 text-blue-700 hover:bg-blue-200 border-blue-300'
      : 'bg-amber-100 text-amber-700 hover:bg-amber-200 border-amber-300';

  const Icon = hasFailed ? AlertTriangle : hasSyncing ? Loader2 : CloudUpload;

  const label = hasFailed
    ? `${counts.failed} failed · ${counts.pending} pending`
    : hasSyncing
      ? `Syncing ${counts.syncing}…`
      : `${counts.pending} pending`;

  return (
    <button
      onClick={triggerSync}
      disabled={!isOnline || hasSyncing}
      className={`hidden sm:flex items-center gap-1.5 px-2.5 py-1 rounded-md border text-xs font-semibold transition-colors ${color} ${!isOnline ? 'opacity-70 cursor-not-allowed' : ''}`}
      title={isOnline ? 'Tap to sync now' : 'Offline — will sync when connection returns'}
      data-testid="pending-sync-badge"
    >
      <Icon size={12} className={hasSyncing ? 'animate-spin' : ''} />
      <span>{label}</span>
    </button>
  );
};
